import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormService} from "../../../services/form.service";
import {FormTO} from "../../../classes/form-to";
import {FileImportTO} from "../../../classes/file-import-to";
import {BooleanTO} from "../../../classes/boolean-to";
import {ModalDirective} from "ngx-bootstrap/modal";
import {ShareTO} from "../../../classes/share-to";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {UserService} from "../../../services/user.service";
import {UserSearchTO} from "../../../classes/user-search-to";
import {UserFormSearchTO} from "../../../classes/user-form-search-to";
import {Router} from "@angular/router";
import {ProcessBuilderService} from "../../../services/process-builder.service";
import {FormPublicationTO} from "../../../classes/form-publication-to";

@Component({
  selector: 'app-form-list',
  templateUrl: './form-list.component.html',
  styleUrls: ['./form-list.component.css'],
})
export class FormListComponent implements OnInit {

  @ViewChild('shareModal') public shareModal: ModalDirective;
  @ViewChild('publishModal') public publishModal: ModalDirective;
  @ViewChild('dangerModal') public dangerModal: ModalDirective;
  @ViewChild('downloadMissingModal') public downloadMissingModal: ModalDirective;
  @ViewChild('viewModal') public viewModal: ModalDirective;

  private fileImportTO: FileImportTO;

  public forms: FormTO[];

  public form: FormTO;
  private tmpForm: FormTO;
  shares: ShareTO[];
  public shareMode = 'list';

  @ViewChild('inputSearchShareUser', { static: false }) inputSearchShareUserElementRef: ElementRef;

  editShareForm = new FormGroup({
    search: new FormControl('', [Validators.required]),
  });
  private shareUserSearchResults: UserSearchTO[];
  private shareUserSearchInit = false;
  pickPrivilegeUser: UserSearchTO;
  sharePrivilegeChoice: string[];
  shareSavedInd: boolean;
  publishedInd: boolean;
  publications: FormPublicationTO[];
  publicationMode = 'list';

  publishForm: FormGroup;


  constructor(private formService: FormService, private userService: UserService, private processBuilderService: ProcessBuilderService, private changeDetectorRef: ChangeDetectorRef, private router: Router) { }

  ngOnInit() {
    this.loadForms();

    this.publishForm = new FormGroup({
      name: new FormControl('', [Validators.required])
    });
  }

  loadForms() {
    this.forms = undefined;
    this.formService.getFormsLite().subscribe(data => {
      // console.log('getFormsLite:');
      // console.dir(data);
      if (data) {
        this.forms = <FormTO[]> data;
      }
    });

  }

  onDeleteForm() {
    this.dangerModal.hide();
    if (this.tmpForm) {
      this.formService.onDeleteForm(this.tmpForm).subscribe(data => {
        // console.log('onDeleteForm:');
        // console.dir(data);
        if (data) {
          const result: BooleanTO = <BooleanTO> data;
          if (result && result.true) {
            this.loadForms();
          } else {
            console.error("Failed to delete form due to message: " + result.message);
          }
        }
      });
    }
  }

  confirmFormDeletion(form: FormTO) {
    this.tmpForm = form;
    this.dangerModal.show();
  }

  viewForm(form: FormTO) {
    if (form) {
      this.form = undefined;
      this.viewModal.show();
      setTimeout(() => {
        if (form.model) {
          this.form = form;
          this.viewModal.show();
        } else {
          if (this.form) this.form.model = undefined;
          this.formService.getFormTOModel(form).subscribe(data => {
            if (data) {
              form.model = <string> data;
              this.form = form;
            }
          });
        }
      }, 500);
    }
  }

  importEvent(fileImportTO: FileImportTO, form: FormTO) {
    // console.log('importEvent');
    // console.dir(fileImportTO);
    form.model = fileImportTO.model;
  }

  onSharing(form: FormTO) {
    this.tmpForm = form;
    this.shareUserSearchInit = false;
    this.shareUserSearchResults = undefined;
    this.loadFormShares();
  }

  loadFormShares() {
    const tmpForm = new FormTO();
    tmpForm.id = this.tmpForm.id;

    this.formService.getFormShares(tmpForm).subscribe(data => {
      if (data) {
        this.shares = <ShareTO[]> data;
        // console.log('this.shares:');
        // console.dir(this.shares);
        this.shareModal.show();
      }
    });

  }

  onEditShare() {
    // console.log('onEditShare');
    this.shareMode = 'edit';
    this.shareUserSearchResults = undefined;
    this.editShareForm.controls.search.setValue('');

    this.changeDetectorRef.detectChanges();
    if (this.inputSearchShareUserElementRef) this.inputSearchShareUserElementRef.nativeElement.focus();

    this.editShareForm.get('search').valueChanges.subscribe(query => {
      // console.log('search.query:');
      // console.dir(query);
      const userFormSearchTO = new UserFormSearchTO();
      userFormSearchTO.query = query;
      userFormSearchTO.formId = this.tmpForm.id;
      this.pickPrivilegeUser = undefined;
      this.sharePrivilegeChoice = undefined;

      this.userService.findUserForm(userFormSearchTO).subscribe(response => {
        this.shareUserSearchInit = true;
        this.shareUserSearchResults = response as UserSearchTO[];

      });
    });
  }

  onShare(userSearchTO: UserSearchTO) {
    // console.log('onShare.userSearchTO:');
    // console.dir(userSearchTO);
    this.pickPrivilegeUser = userSearchTO;
  }

  onListShares() {
    this.shareMode = 'list';
    this.loadFormShares();
  }

  onSavePrivilege(user: UserSearchTO) {
    // console.log('onSavePrivilege.sharePrivilegeChoice:');
    // console.dir(this.sharePrivilegeChoice);
    // console.dir(user.userId);

    // this.pickPrivilegeUser.privilege = this.sharePrivilegeChoice;
    // this.pickPrivilegeUser.formId = this.tmpForm.id;
    user.formId = this.tmpForm.id;
    this.userService.saveShare(user).subscribe(response => {
      const booleanTO = response as BooleanTO;
      // console.log('saveShare.booleanTO');
      // console.dir(booleanTO);
      // this.pickPrivilegeUser.saved = true;
      // this.shareSavedInd = true;
      // setTimeout(() => {
      //   this.pickPrivilegeUser.saved = undefined;
      //   this.shareSavedInd = undefined;
      // }, 3000);
    });
  }

  onRevokeShare(share: ShareTO) {
    share.formId = this.tmpForm.id;
    this.userService.revokeShare(share).subscribe(response => {
      const booleanTO = response as BooleanTO;
      if (booleanTO.true) this.loadFormShares();
    });
  }

  onRevokeShareUser(userSearchTO: UserSearchTO) {
    userSearchTO.formId = this.tmpForm.id;
    this.userService.revokeShareUser(userSearchTO).subscribe(response => {
      const booleanTO = response as BooleanTO;
      if (booleanTO.true) this.loadFormShares();
      userSearchTO.privilege = undefined;
    });

  }

  onProcessBuilder(form: FormTO) {
    console.log('onProcessBuilder');
    console.dir(form);
    this.processBuilderService.form = form;
    this.router.navigateByUrl('design/process/builder',{ skipLocationChange: false });
  }



  onGetPublicationName() {
    console.log('onGetPublicationName');
    this.tmpForm.publicationName = undefined;
    this.publicationMode = 'name';
  }

  onPublish() {
    console.log('onPublish');
    console.log('onPublish.this.publishForm.get(\'name\').value:');
    console.dir(this.publishForm.get('name').value);

    this.tmpForm.publicationName = this.publishForm.get('name').value;

    this.formService.publishForm(this.tmpForm).subscribe(publication => {
      console.log('publication:');
      console.dir(publication);

      this.tmpForm.publicationName = undefined;
      this.publicationMode = 'list';

      this.getFormPublications(function () {
      });
    });
  }

  onPublishModal(form: FormTO) {
    console.log('onPublishModal');
    this.tmpForm = form;
    this.publications = undefined;

    // this.formService.getFormPublications(this.tmpForm).subscribe(publications => {
    //   this.publications = publications;
    // });

    this.getFormPublications(function (modal: ModalDirective) {
      modal.show();
    });

  }

  getFormPublications(callback: any) {
    this.formService.getFormPublications(this.tmpForm).subscribe(publications => {
      this.publications = publications;
      callback(this.publishModal);
    });
  }

  onCancelPublication() {
    console.log('onCancelPublication');
    this.publishModal.hide()
  }

  download(form: FormTO) {
    this.formService.hasExport(form.id).subscribe(booleanTO => {
      if (booleanTO && booleanTO.true) {
        window.location.assign('/rest/form/export?f=' + form.id);
      } else {
        this.downloadMissingModal.show();
      }
    });
  }
}
